let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("awzsc")).then(() => parcelRequire('hWThq'));